import React from "react";
import { FileText } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { SIX_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createEmailBody, createEmailBodyVersion, getEmailBodies, updateEmailBodyMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: Email Bodies authoring (EML-SPEC-001). Plain governed
// content authoring for now, per checkpoint §11 -- no rich-text builder,
// no drag/drop, no HTML editor, no Builder canvas. Line breaks preserved
// exactly (a plain <textarea> never collapses them).
const config = {
  familyCode: "EML",
  testIdPrefix: "email-bodies",
  idField: "email_body_id",
  contentField: "canonical_email_body",
  contentLabel: "Canonical Email Body",
  contentInputType: "textarea",
  contentPlaceholder: "Hi {{first_name}},\n\n...",
  labelSingular: "Email Body",
  labelPlural: "Email Bodies",
  icon: FileText,
  statusValues: SIX_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable email body (EML####).",
  api: {
    list: getEmailBodies,
    create: ({ name, status, content }) => createEmailBody({ name, status, canonicalEmailBody: content }),
    createVersion: (id, { version, content }) => createEmailBodyVersion(id, { version, canonicalEmailBody: content }),
    updateMetadata: (id, { name, status }) => updateEmailBodyMetadata(id, { name, status }),
  },
};

export default function EmailBodiesPanel() {
  return <AssetFamilyPanel config={config} />;
}
